import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../../hooks/hooks';
import { vehicles } from '../../../../../../redux/vehicles/action';
import VehicleComponent from '../components/vehicle.component';
import { agents } from '../../../../../../redux/agents/action';
import { selectTransportersListItems } from '../../../../../../redux/transporters/selector';
import { selectVehiclesQueryItems } from '../../../../../../redux/vehicles/selector';
import { selectAgentsListItems } from '../../../../../../redux/agents/selector';
import PageLoader from '../../../../../../components/PageLoader';
import { transporters } from '../../../../../../redux/transporters/action';
import { selectListItems } from '../../../../../../redux/library/selector';
import { settings } from '../../../../../../redux/settings/actions';
import { selectCurrent } from '../../../../../../redux/settings/selectors';
import UploadFiles from '../../../../../../models/UploadFile';
import { deepCopy } from '../../../../../../common/services/common.service';

let currentChange: any = {}
const ManagementVehicle = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const libraryData = useSelector(selectListItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const vehicleQuery = useSelector(selectVehiclesQueryItems)
  const transportAgentListItems = useSelector(selectAgentsListItems)
  const transporterListItems = useSelector(selectTransportersListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedVehicle,
    setSelectedVehicle
  ] = useState<any>([])
  const [
    vehicleImageIndex,
    setVehicleImageIndex
  ] = useState<any>([])
  const [
    openFile,
    setOpenFile
  ] = useState<any>([]);
  const [
    mediaFiles,
    setMediaFiles
  ] = useState<any>([])

  const fetchVehicleById = () => {
    dispatch(vehicles.query({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/vehicle-registations/query`, entity: 'vehicles', jsonData: {

        Records: [
          {
            Id: parmas?.id
          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    }).then(() => {
      setIsLoading(false)
    })
  }

  const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
    const localSelectedmedia = deepCopy(selectedMediaFilesArg)
    const newsSelectedMedia = {
      Id: 0,
      FileTypeId: 0,
      OwnerId: parmas?.id,
      OwnerType: 'VehicleRegistration',
      OwnerTypeId: 1007,
      FileMappingURL: ''
    }
    if (localSelectedmedia.length === 0 ||
      localSelectedmedia[localSelectedmedia?.length - 1]?.FileTypeId !== 0
    ) {
      localSelectedmedia?.push(newsSelectedMedia)
    }

    return localSelectedmedia
  }
  const setMediaInfo = async () => {
    let localSelectedMedia = deepCopy(mediaFiles)
    localSelectedMedia.splice(
      currentChange.idx,
      1,
      { ...localSelectedMedia[currentChange.idx] }
    );
    localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
    currentChange.field = 'FileTypeIdDONE'
    setMediaFiles(localSelectedMedia)
  }
  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedVehicle({ ...selectedVehicle, [field]: event });
  }

  const changeImage = (idx: number, templateField: any, fileType: any) => {
    setVehicleImageIndex(idx)
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenFile({
      currentFileSrc: mediaFiles[idx][templateField],
      folder: 'VehicleRegistration',
      type: fileType
    })
  }
  const handleSubmit = (data: any) => {

    mediaFiles[vehicleImageIndex].FileMappingURL = data
    const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
    setMediaFiles(localSelectedMedia)
  }

  useEffect(
    () => {
      dispatch(agents.list({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/transport-agents/list`, entity: 'agents', jsonData: {

        }
      })).then(() => {
        dispatch(transporters.list({
          url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/transporters/list`, entity: 'transporters', jsonData: {

          }
        }))
      }).then(() => {
        if (parmas?.id > 0) {
          fetchVehicleById()
          setIsLoading(false)
        } else {
          const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
          setMediaFiles(localSelectedMedia)
          setIsLoading(false)

        }
      })
    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        setSelectedVehicle(vehicleQuery?.result?.items)
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: vehicleQuery?.result?.items?.MediaMappings?.MediaFiles });
        setMediaFiles(localSelectedMedia)
      }
    },
    [isQuery]
  )

  const handleClose = () => {
    dispatch(settings.set({ getUploadFiles: 'close' }))

  }
  const handleFormMediaItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(mediaFiles);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMediaFiles(items);
  }

  useEffect(
    () => {
      if (currentChange.field === 'FileTypeId') {
        setMediaInfo()
      }
    },
    [mediaFiles]
  )
  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    mediaFiles.splice(
      mediaFiles.length - 1,
      1
    )
    const vehicleData = {

      ...selectedVehicle,
      MediaMappings: {
        ...selectedVehicle?.MediaMappings,
        MediaFiles: mediaFiles
      },

    }
    if (parmas?.id > 0) {
      await dispatch(vehicles.resetAction({ actionType: 'update' }))
      await dispatch(vehicles.update({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/vehicle-registations`, entity: 'vehicles', jsonData: {

          Records: [
            vehicleData
          ]

        }
      })).then(() => {
        back()
      });

    } else {
      await dispatch(vehicles.resetAction({ actionType: 'create' }))
      await dispatch(vehicles.create({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/vehicle-registations`, entity: 'vehicles', jsonData: {

          Records: [
            vehicleData
          ]

        }
      })).then(() => {
        back()
      });
    }
  }

  const back = () => {
    navigate('/management/logistics/transport/vehicle-registations')
  }

  return (
    <>
      {getUploadFiles == 'open' && <UploadFiles currentFilesSrc={openFile?.currentFileSrc}
        folder={openFile?.folder}
        handleClose={handleClose}
        handleFilesSubmit={handleSubmit}
        type={openFile?.type}
        ownerId={parmas?.id}
      />}

      {isLoading ? <PageLoader /> :
        <VehicleComponent
          mediaFiles={mediaFiles}
          handleFormMediaItemChange={handleFormMediaItemChange}
          fileTypes={libraryData?.result?.FileType}
          changeImage={changeImage}
          handleInnerFormChange={handleInnerFormChange}
          selectedVehicle={selectedVehicle}
          transportAgents={transportAgentListItems?.result?.items}
          transporters={transporterListItems?.result?.items}
          back={back}
          handleFormSubmit={handleFormSubmit}
        />
      }
    </>
  )

}

export default ManagementVehicle;